(() => {
  const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  if (forms.length === 0) return;

  /**
   * 更新頁面上所有購物車數量顯示（導覽列 badge、文字數量）
   * @param {number} count - 購物車商品總數
   * @returns {void}
   */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 99 ? '99+' : String(count);
      // 只有導覽列的圓形 badge 在數量為 0 時要隱藏；一般文字數量固定顯示
      if ('cartCountBadge' in el.dataset) el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
      const template = el.dataset.cartCountLabel;
      if (template) el.setAttribute('aria-label', template.replace('__COUNT__', count));
    });
  }

  /**
   * 暫時把按鈕文字換成完成訊息，再還原
   * @param {HTMLButtonElement} button
   * @param {string} message - 要暫時顯示的文字
   * @returns {void}
   */
  function flashButton(button, message) {
    if (button.dataset.flashing === 'true') return;
    const original = button.textContent;
    button.dataset.flashing = 'true';
    button.textContent = message;
    button.classList.add('is-added');
    window.setTimeout(() => {
      button.textContent = original;
      button.classList.remove('is-added');
      button.dataset.flashing = 'false';
    }, 1800);
  }

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      // 只攔截「加入購物車」，動態結帳按鈕（Shop Pay 等）維持原生行為
      if (!submitter || submitter.name !== 'add') return;

      event.preventDefault();
      const messages = document.querySelector('[data-cart-add-messages]');
      const addedText = messages?.dataset.added || '已加入購物車';
      const errorText = messages?.dataset.error || '加入購物車失敗，請重試';

      submitter.disabled = true;

      try {
        const addResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!addResponse.ok) {
          const error = await addResponse.json().catch(() => ({}));
          throw new Error(error.description || `Add to cart failed: ${addResponse.status}`);
        }

        // 「立即購買」：加入後直接前往購物車頁，讓客人在那裡填發票資訊再結帳
        if ('buyNow' in submitter.dataset) {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          return;
        }

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count);
        }

        flashButton(submitter, addedText);
      } catch (error) {
        console.error(error);
        window.alert(errorText);
      } finally {
        submitter.disabled = false;
      }
    });
  });
})();
